module.exports = __webpack_public_path__ + "img/percent.4b81d568.svg";